import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../../Component/DigitalMarketing/SearchBox";
import { useDispatch, useSelector } from "react-redux";
import { Change } from "../../../../store/async-actions/digitalmarketing/header";
import DashTable from "./DashTable";
import Pagination from "../../../../Component/DigitalMarketing/Pagination";
import ViewTestOrders from "./ViewTestOrders";
import { useGetTestOrdersQuery } from "../../../../Service/LabManagement";
import Loader from "../../../../Component/DigitalMarketing/Loader";
import DashTabs from "./DashTabs";

const TestOrders = () => {
  const [show, setShow] = useState(false);
  const [view, setView] = useState(false);
  const [updateData, setUpdateData] = useState(null); // For selected test order data
  const [pagination, setPagination] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const account = useSelector((state: any) => state.auth);
  const {roleName} = account
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const {
    data: TestOrderData,
    isLoading,
    refetch,
  } = useGetTestOrdersQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    setPagination(1); // Reset pagination when search value changes
  }, [searchValue]);

  useEffect(() => {
    const data:any = {
      first: "Test Orders"
    };
    dispatch(Change(data));
  }, [show, updateData, view, dispatch]);
  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <div>
      <Row>
        <Col md={5}>
          <SearchBox value={searchValue} onChange={onChangeSearch} />
        </Col>
        {(show && roleName !== "receptionist") &&(
          <Col md={7} className="d-flex justify-content-end">
            {view && <DashTabs show={show} setShow={setShow} />}
          </Col>
        )}
      </Row>

      <div className="row mt-4">
        <div className={show ? "col-8" : "col-12"}>
          <DashTable
            setShow={setShow}
            setUpdateData={setUpdateData}
            setView={setView}
            type="Order"
            list={TestOrderData}
          />
        </div>
        {show && (
          <div className="col-4" style={{ backgroundColor: "white" }}>
            <ViewTestOrders
              updateData={updateData}
              view={view}
              setShow={setShow}
            />
          </div>
        )}
        <Pagination
          setPagination={setPagination}
          pagination={pagination}
          data={TestOrderData}
        />
      </div>
    </div>
  );
};

export default TestOrders;
